// src/pages/MeetingRoom/ui/NatureTable.jsx
import React, { useState } from "react";

/**
 * Flat, minimal table — square or pill-shaped.
 *
 * shape prop
 * ──────────
 * "square"    → default (capacity 4 / 8)
 * "rect-6"    → wide pill  (capacity 6, or vertical pill on mobile)
 * "rect-10"   → wider pill (capacity 10, or taller vertical pill on mobile)
 */
export default function NatureTable({
  tableName,
  tableIcon,
  onPressSponsor,
  shape = "square",
}) {
  const [imgOk, setImgOk] = useState(true);

  return (
    <div className="jt-tableWrap jt-tableWrap--flat" data-shape={shape} aria-hidden="true">
      <div className="jt-tableTop jt-tableTop--flat" data-shape={shape}>
        <div className="jt-tableFelt jt-tableFelt--flat" data-shape={shape}>
          <div className="jt-tableCenter">
            <button
              type="button"
              className="jt-tableIconBtn"
              onClick={onPressSponsor}
              title="Meeting"
            >
              {tableIcon && imgOk ? (
                <div className="jt-tableIcon">
                  <img
                    className="jt-img"
                    src={tableIcon}
                    alt=""
                    onError={() => setImgOk(false)}
                  />
                </div>
              ) : (
                <span className="jt-tableFallback">🌲</span>
              )}
            </button>

            <div className="jt-tableName" title={tableName}>
              {tableName}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}